import { ConfirmDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ConfirmDialog')
export class ConfirmDialogNodeConnectorProvider extends ConnectorProvider<ConfirmDialogWorkflowNode> {}
